import { IProductFilter } from '@/models/products.model';

export const getFilterOptions = (filter: IProductFilter) =>
  filter.values.map((el) => ({ value: el.id, label: el.title }));

export const getFilterDefaultValue = (filter: IProductFilter) => {
  const selectedValues = filter.values.filter((el) => !!el.selected).map((el) => el.id);
  return selectedValues.length > 1 ? selectedValues : selectedValues[0];
};
